<template lang="pug">
  dv-maska-field(
    v-model="inputValue"
    v-bind="extraAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")

</template>

<script>
import DvMaskaField from './DvMaskaField.vue';

export default {
  components: {
    DvMaskaField,
  },
  props: {
    value: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      inputValue: undefined,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.inputValue = val;
      },
      immediate: true,
    },
    inputValue: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.$emit('input', this.serializeOutput(newValue));
        }
      },
      immediate: true,
    },
  },
  computed: {
    maskaOptions() {
      return {
        mask: '###-###-### ##',
        tokens: {
          '#': {
            pattern: /[0-9]/,
          },
        },
        returnMasked: true,
      };
    },
    extraAttrs() {
      const { $attrs, maskaOptions } = this;

      return {
        placeholder: '___-___-___ __',
        ...$attrs,
        maskaOptions,
      };
    },
  },
  methods: {
    serializeOutput(val) {
      return val.replace(/\D/g, '');
    },
  },
};
</script>
